/**
 * Fragments permission ids used by export / social publish UI.
 * Kept local to avoid importing generated API permission maps.
 */
export const fragmentsPermissions = {
  Fragments_SocialPublish: 'fragments:fragments:social-publish',
  Fragments_Delivery: 'fragments:fragments:delivery',
} as const;
